module.exports = __webpack_public_path__ + "img/comparativeReport.dcf2dd12.svg";